
import React, { useEffect, useState } from 'react'
import { Grid, Menu, Button, Dropdown, Icon, Ref, Sticky, Container } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {  SetShowSearchBox } from "../../../../../redux/actions/mainActions"
import LanguageHandler from '../../../components/LanguageHandler/LanguageHandler';
import "./AppBar.css"

const AppBar = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
 
    const searchHandler = () => {
        dispatch(SetShowSearchBox(true))
    }
  
    
    return <Menu fixed='bottom'
        secondary={true}
        className='AppBar-mobile bg-white  p-0 m-0 justify-content-center'
    >
        <Container>
            <Grid unstackable className="w-100 m-0" columns={4}>
                <Grid.Column className="p-0">
                    <Menu.Item  className='w-100'>
                       <Button  className='w-100 btn-transparent d-flex flex-column align-items-center justify-content-center '>
                           <Icon color='red' className='m-05 font-20px'  name='search'/>
                           Explore
                       </Button>
                    </Menu.Item>
                </Grid.Column>
                <Grid.Column className="p-0">
                    <Menu.Item  className='w-100'>
                       <Button  className='w-100 btn-transparent d-flex flex-column align-items-center justify-content-center '>
                           <Icon color='red' className='m-05 font-20px'  name='heart'/>
                           Wishlists
                       </Button>
                    </Menu.Item>
                </Grid.Column>
                <Grid.Column className="p-0">
                    <Menu.Item  className='w-100'>
                       <Button  className='w-100 btn-transparent d-flex flex-column align-items-center justify-content-center '>
                           <Icon color='red' className='m-05 font-20px'  name='user circle outline'/>
                           Log in
                       </Button>
                    </Menu.Item>
                </Grid.Column>
                <Grid.Column className="p-0">
                    <Menu.Item  className='w-100'>
                       <LanguageHandler/>
                    </Menu.Item>
                </Grid.Column>
            </Grid>
        </Container>
    </Menu>
}
export default AppBar